import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

const CountdownTimer = (props) => {
  const { timestamp = 0, reloadFunc = () => {} } = props;

  const [currentTime, setCurrentTime] = useState("--:--:--");

  useEffect(() => {
    const intervalId = setInterval(() => {
      const diff = timestamp - dayjs().unix();
      if (diff < 0) return;
      if (diff === 0) {
        reloadFunc();
      }

      setCurrentTime(dayjs.duration(diff, "seconds").format("HH:mm:ss"));
    }, 1000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [timestamp, reloadFunc]);

  return <>{currentTime}</>;
};

export default CountdownTimer;
